import React from "react";
import { Link } from "react-router-dom";
import { LuLock, LuMail } from "react-icons/lu";
import { Brand } from "./Topbar";
import { TOOLS } from "./tools";

const FORMAT_PAGES = [
  ["/edifact-excel-konverter", "EDIFACT → Excel"],
  ["/edifact-csv-konverter", "EDIFACT → CSV"],
  ["/edifact-xml-konverter", "EDIFACT → XML"],
  ["/edifact-json-konverter", "EDIFACT → JSON"],
];

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Brand />
            <p>
              Kostenlose Online-Tools, um EDIFACT-Dateien zu öffnen, zu prüfen und umzuwandeln –
              die Verarbeitung läuft vollständig lokal in deinem Browser.
            </p>
            <div className="footer-badges">
              <span className="badge badge-neutral"><LuLock size={13} aria-hidden="true" />100 % lokal</span>
              <span className="badge badge-neutral">Entwickelt in Österreich</span>
            </div>
          </div>

          <div>
            <div className="footer-title">Tools</div>
            <ul className="footer-links">
              {TOOLS.map(t => <li key={t.to}><Link to={t.to}>EDIFACT {t.name}</Link></li>)}
            </ul>
          </div>

          <div>
            <div className="footer-title">Formate & Wissen</div>
            <ul className="footer-links">
              {FORMAT_PAGES.map(([to, label]) => <li key={to}><Link to={to}>{label}</Link></li>)}
              <li><Link to="/glossar">EDIFACT-Glossar</Link></li>
              <li><Link to="/blog">Blog</Link></li>
            </ul>
          </div>

          <div>
            <div className="footer-title">Rechtliches</div>
            <ul className="footer-links">
              <li><Link to="/impressum">Impressum</Link></li>
              <li><Link to="/datenschutz">Datenschutz</Link></li>
              <li><a href="mailto:ediconverter.de@gmail.com"><LuMail size={13} aria-hidden="true" style={{ marginRight: 6, verticalAlign: "-1px" }} />Kontakt</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} edi-converter.de · Alle Rechte vorbehalten</span>
          <span>Nur für unkritische Test- und Lerndaten · Keine Haftung</span>
        </div>
      </div>
    </footer>
  );
}
